/**
   * GNS Curated Collection Router v3.1
   * Routes filter selections to curated collection pages
   */

  // ============================================================
  // GID → Token Map (Complete)
  // ============================================================
  const GID_TO_TOKEN = {
    // taxonomy.hazard (16)
    "gid://shopify/Metaobject/200172929362": "anti-static",
    "gid://shopify/Metaobject/200171094354": "anti-vibration",
    "gid://shopify/Metaobject/223388107090": "arc-flash",
    "gid://shopify/Metaobject/198774358354": "chemical",
    "gid://shopify/Metaobject/198775144786": "cold",
    "gid://shopify/Metaobject/198773834066": "cut-resistant",
    "gid://shopify/Metaobject/200172372306": "electrical",
    "gid://shopify/Metaobject/232781611346": "esd-protection",
    "gid://shopify/Metaobject/232781709650": "extreme-cold",
    "gid://shopify/Metaobject/208611508562": "flame-resistant",
    "gid://shopify/Metaobject/198774948178": "heat-resistant",
    "gid://shopify/Metaobject/200148255058": "impact",
    "gid://shopify/Metaobject/198774063442": "needle",
    "gid://shopify/Metaobject/221003415890": "oil-resistant",
    "gid://shopify/Metaobject/232781644114": "sun-protection",
    "gid://shopify/Metaobject/248598266194": "virus-protection",
    // taxonomy.feature (29)
    "gid://shopify/Metaobject/200184398162": "abrasion",
    "gid://shopify/Metaobject/200521777490": "anti-syringe",
    "gid://shopify/Metaobject/200180990290": "biodegradable",
    "gid://shopify/Metaobject/198787531090": "breathable",
    "gid://shopify/Metaobject/232781087058": "cooling",
    "gid://shopify/Metaobject/198787432786": "disposable",
    "gid://shopify/Metaobject/232781185362": "eco",
    "gid://shopify/Metaobject/200174731602": "fingerless",
    "gid://shopify/Metaobject/200185315666": "heavy-duty",
    "gid://shopify/Metaobject/200184562002": "hi-vis",
    "gid://shopify/Metaobject/246832038226": "high-dexterity",
    "gid://shopify/Metaobject/232781152594": "insulated",
    "gid://shopify/Metaobject/232780890450": "lightweight",
    "gid://shopify/Metaobject/232781119826": "odour-control",
    "gid://shopify/Metaobject/200181711186": "polka-dot",
    "gid://shopify/Metaobject/257138721106": "powder-free",
    "gid://shopify/Metaobject/232780923218": "reinforced-knees",
    "gid://shopify/Metaobject/200183972178": "rigger",
    "gid://shopify/Metaobject/200182595922": "sterile",
    "gid://shopify/Metaobject/232780988754": "stretch-dx-4",
    "gid://shopify/Metaobject/198787596626": "thermal",
    "gid://shopify/Metaobject/198805160274": "thin",
    "gid://shopify/Metaobject/200176337234": "thinsulate",
    "gid://shopify/Metaobject/222034985298": "thumb-crotch",
    "gid://shopify/Metaobject/232781021522": "tool-pockets",
    "gid://shopify/Metaobject/198787367250": "touchscreen",
    "gid://shopify/Metaobject/232781054290": "uv-protection",
    "gid://shopify/Metaobject/198787170642": "waterproof",
    "gid://shopify/Metaobject/200173879634": "windproof",
    // taxonomy.industry (25)
    "gid://shopify/Metaobject/232775582034": "automotive",
    "gid://shopify/Metaobject/204191760722": "blacksmith",
    "gid://shopify/Metaobject/200191312210": "bricklaying",
    "gid://shopify/Metaobject/200194228562": "butchers",
    "gid://shopify/Metaobject/200194621778": "carpenter",
    "gid://shopify/Metaobject/200194720082": "chainsaw",
    "gid://shopify/Metaobject/200193933650": "cleaner",
    "gid://shopify/Metaobject/198787793234": "construction",
    "gid://shopify/Metaobject/200192852306": "cryogenic",
    "gid://shopify/Metaobject/200179614034": "driving",
    "gid://shopify/Metaobject/200190001490": "electrician",
    "gid://shopify/Metaobject/200194654546": "farming",
    "gid://shopify/Metaobject/200431010130": "food",
    "gid://shopify/Metaobject/200189083986": "freezer",
    "gid://shopify/Metaobject/200162476370": "gardening",
    "gid://shopify/Metaobject/200194326866": "glass-handling",
    "gid://shopify/Metaobject/200193999186": "hospital",
    "gid://shopify/Metaobject/200162378066": "mechanics",
    "gid://shopify/Metaobject/261004493138": "mining",
    "gid://shopify/Metaobject/200194490706": "plumbing",
    "gid://shopify/Metaobject/241355358546": "railway",
    "gid://shopify/Metaobject/200194097490": "scaffolding",
    "gid://shopify/Metaobject/200194752850": "tattoo",
    "gid://shopify/Metaobject/200191181138": "warehouse",
    "gid://shopify/Metaobject/200162443602": "welding",
    // taxonomy.liner (19)
    "gid://shopify/Metaobject/220979724626": "liner:acrylic",
    "gid://shopify/Metaobject/220979921234": "liner:aramid",
    "gid://shopify/Metaobject/220979691858": "liner:cotton",
    "gid://shopify/Metaobject/248612258130": "liner:fiber-glass",
    "gid://shopify/Metaobject/220979790162": "liner:hppe",
    "gid://shopify/Metaobject/232776270162": "liner:laminated-film",
    "gid://shopify/Metaobject/252605038930": "liner:latex",
    "gid://shopify/Metaobject/220980314450": "liner:latex-free",
    "gid://shopify/Metaobject/220979888466": "liner:leather",
    "gid://shopify/Metaobject/232776237394": "liner:microporous",
    "gid://shopify/Metaobject/248612290898": "liner:modacrylic",
    "gid://shopify/Metaobject/220997910866": "liner:neoprene",
    "gid://shopify/Metaobject/220979528018": "liner:nylon",
    "gid://shopify/Metaobject/245813805394": "liner:polycotton",
    "gid://shopify/Metaobject/220979626322": "liner:polyester",
    "gid://shopify/Metaobject/232776204626": "liner:sms",
    "gid://shopify/Metaobject/220979855698": "liner:spandex",
    "gid://shopify/Metaobject/220979822930": "liner:unlined",
    "gid://shopify/Metaobject/223365562706": "liner:vinyl",
    // custom.material_data / coating (15)
    "gid://shopify/Metaobject/220994928978": "coating:dual-coated",
    "gid://shopify/Metaobject/220994502994": "coating:foam-nitrile",
    "gid://shopify/Metaobject/220994863442": "coating:fully-coated",
    "gid://shopify/Metaobject/220994765138": "coating:knuckle-coated",
    "gid://shopify/Metaobject/222764302674": "coating:latex",
    "gid://shopify/Metaobject/220994568530": "coating:latex-crinkle",
    "gid://shopify/Metaobject/220994699602": "coating:latex-foam",
    "gid://shopify/Metaobject/200160706898": "coating:latex-free",
    "gid://shopify/Metaobject/200160477522": "coating:nitrile",
    "gid://shopify/Metaobject/220994732370": "coating:palm-coated",
    "gid://shopify/Metaobject/200160870738": "coating:pu",
    "gid://shopify/Metaobject/200160772434": "coating:pvc",
    "gid://shopify/Metaobject/200160444754": "coating:rubber",
    "gid://shopify/Metaobject/220994535762": "coating:sandy-nitrile",
    "gid://shopify/Metaobject/220994961746": "coating:uncoated",
    // custom.material_composition (13)
    "gid://shopify/Metaobject/263178158418": "material:100-cotton",
    "gid://shopify/Metaobject/263178420562": "material:acrylic",
    "gid://shopify/Metaobject/263232356690": "material:latex",
    "gid://shopify/Metaobject/263178846546": "material:leather",
    "gid://shopify/Metaobject/263232389458": "material:nitrile",
    "gid://shopify/Metaobject/263178649938": "material:nylon",
    "gid://shopify/Metaobject/263178584402": "material:polyamide",
    "gid://shopify/Metaobject/263182287186": "material:polycotton",
    "gid://shopify/Metaobject/263178256722": "material:polyester",
    "gid://shopify/Metaobject/263232422226": "material:pu",
    "gid://shopify/Metaobject/263233012050": "material:pvc",
    "gid://shopify/Metaobject/263232880978": "material:rubber",
    "gid://shopify/Metaobject/263178748242": "material:vinyl",
    // custom.cut_level (6)
    "gid://shopify/Metaobject/200142520658": "cut-level:5",
    "gid://shopify/Metaobject/198790185298": "cut-level:b",
    "gid://shopify/Metaobject/198790218066": "cut-level:c",
    "gid://shopify/Metaobject/198790283602": "cut-level:d",
    "gid://shopify/Metaobject/198790316370": "cut-level:e",
    "gid://shopify/Metaobject/198790349138": "cut-level:f",
    // custom.gender (3)
    "gid://shopify/Metaobject/232776794450": "gender:men",
    "gid://shopify/Metaobject/232776859986": "gender:unisex",
    "gid://shopify/Metaobject/232776827218": "gender:women",
    // custom.hi_vis (3)
    "gid://shopify/Metaobject/232781250898": "hi-vis:class-1",
    "gid://shopify/Metaobject/232781316434": "hi-vis:class-2",
    "gid://shopify/Metaobject/232781349202": "hi-vis:class-3",
    // custom.lens_tint (5)
    "gid://shopify/Metaobject/232787181906": "lens:clear",
    "gid://shopify/Metaobject/232787280210": "lens:mirror",
    "gid://shopify/Metaobject/232787378514": "lens:polarised",
    "gid://shopify/Metaobject/232787214674": "lens:smoke",
    "gid://shopify/Metaobject/232787312978": "lens:yellow",
    // custom.respiratory_protection (4)
    "gid://shopify/Metaobject/232797864274": "resp:face-fit-test",
    "gid://shopify/Metaobject/232797765970": "resp:ffp1",
    "gid://shopify/Metaobject/232797667666": "resp:ffp2",
    "gid://shopify/Metaobject/232797536594": "resp:ffp3",
    // custom.shoe_style (8)
    "gid://shopify/Metaobject/232782070098": "shoe:casual-footwear",
    "gid://shopify/Metaobject/232781906258": "shoe:chukka-boots",
    "gid://shopify/Metaobject/232781939026": "shoe:dealer-boots",
    "gid://shopify/Metaobject/232781971794": "shoe:executive-shoes",
    "gid://shopify/Metaobject/232781807954": "shoe:safety-boots",
    "gid://shopify/Metaobject/232781873490": "shoe:safety-shoes",
    "gid://shopify/Metaobject/232781840722": "shoe:safety-trainers",
    "gid://shopify/Metaobject/232782004562": "shoe:wellington-boots",
    // custom.shoes_standards (25)
    "gid://shopify/Metaobject/250846675282": "shoe-std:aluminium-toe-cap",
    "gid://shopify/Metaobject/232778006866": "shoe-std:cold-insulating",
    "gid://shopify/Metaobject/232778236242": "shoe-std:composite-midsole",
    "gid://shopify/Metaobject/232777941330": "shoe-std:composite-toe-cap",
    "gid://shopify/Metaobject/232778072402": "shoe-std:energy-absorbing-heel",
    "gid://shopify/Metaobject/232778105170": "shoe-std:metal-free",
    "gid://shopify/Metaobject/232778203474": "shoe-std:metatarsal-protection",
    "gid://shopify/Metaobject/232778039634": "shoe-std:puncture-resistant",
    "gid://shopify/Metaobject/232777711954": "shoe-std:s-1",
    "gid://shopify/Metaobject/232777384274": "shoe-std:s-2",
    "gid://shopify/Metaobject/232777548114": "shoe-std:s-3",
    "gid://shopify/Metaobject/232777744722": "shoe-std:s-3-l",
    "gid://shopify/Metaobject/232777417042": "shoe-std:s-3-s",
    "gid://shopify/Metaobject/232777580882": "shoe-std:s-4",
    "gid://shopify/Metaobject/232777449810": "shoe-std:s-5-l",
    "gid://shopify/Metaobject/232777810258": "shoe-std:s-5-s",
    "gid://shopify/Metaobject/232777613650": "shoe-std:s-6",
    "gid://shopify/Metaobject/232777482578": "shoe-std:s-7",
    "gid://shopify/Metaobject/232777875794": "shoe-std:s-7-s",
    "gid://shopify/Metaobject/250667598162": "shoe-std:s-7l",
    "gid://shopify/Metaobject/232777351506": "shoe-std:sb",
    "gid://shopify/Metaobject/232777515346": "shoe-std:sbh",
    "gid://shopify/Metaobject/232778170706": "shoe-std:slip-resistant",
    "gid://shopify/Metaobject/232778137938": "shoe-std:steel-midsole",
    "gid://shopify/Metaobject/232777974098": "shoe-std:steel-toe-cap",
    // custom.snr_level (14)
    "gid://shopify/Metaobject/232789082450": "snr:22-db",
    "gid://shopify/Metaobject/232789115218": "snr:23-db",
    "gid://shopify/Metaobject/232789147986": "snr:26-db",
    "gid://shopify/Metaobject/232789180754": "snr:27-db",
    "gid://shopify/Metaobject/232789213522": "snr:28-db",
    "gid://shopify/Metaobject/232789246290": "snr:29-db",
    "gid://shopify/Metaobject/232789279058": "snr:30-db",
    "gid://shopify/Metaobject/232789311826": "snr:32-db",
    "gid://shopify/Metaobject/232789344594": "snr:34-db",
    "gid://shopify/Metaobject/232789475666": "snr:35-db",
    "gid://shopify/Metaobject/232789541202": "snr:36-db",
    "gid://shopify/Metaobject/232789573970": "snr:37-db",
    "gid://shopify/Metaobject/232789606738": "snr:38-db",
    "gid://shopify/Metaobject/232789672274": "snr:39-db",
    // custom.workwear (6)
    "gid://shopify/Metaobject/232776008018": "workwear:4-way-stretch",
    "gid://shopify/Metaobject/232775975250": "workwear:kneepads-pockets",
    "gid://shopify/Metaobject/254628430162": "workwear:long-sleeve",
    "gid://shopify/Metaobject/232775909714": "workwear:multi-pocket",
    "gid://shopify/Metaobject/254628462930": "workwear:short-sleeve",
    "gid://shopify/Metaobject/232775942482": "workwear:tool-pockets",
    // specs.chem_type (20)
    "gid://shopify/Metaobject/232776499538": "chem:type-3",
    "gid://shopify/Metaobject/232776532306": "chem:type-4",
    "gid://shopify/Metaobject/232776565074": "chem:type-5",
    "gid://shopify/Metaobject/232776630610": "chem:type-6",
    "gid://shopify/Metaobject/200170340690": "chem:type-a",
    "gid://shopify/Metaobject/200202813778": "chem:type-b",
    "gid://shopify/Metaobject/200202846546": "chem:type-c",
  };

  // ============================================================
  // Vendor to Token Map (String-based, not GID)
  // ============================================================
  const VENDOR_TO_TOKEN = {
    "Dunlop": "vendor:dunlop"
  };

  // ============================================================
  // Curated Collections Mapping
  // ============================================================
  const CURATED = {
    // Hazard + Hazard
    "cut-resistant+heat-resistant": "/collections/heat-and-cut-resistant-gloves",
    "cut-resistant+impact": "/collections/cut-resistant-impact-gloves",
    "chemical+cut-resistant": "/collections/cut-resistant-chemical-resistant-gloves",
    "cold+heat-resistant": "/collections/heat-cold-resistant-work-gloves",
    // Hazard + Industry
    "cut-resistant+mechanics": "/collections/cut-resistant-mechanics-gloves",
    "cut-resistant+welding": "/collections/cut-resistant-welding-gloves",
    "cut-resistant+food": "/collections/cut-resistant-food-gloves",
    // Hazard + Coating
    "coating:rubber+cut-resistant": "/collections/cut-resistant-rubber-gloves",
    // Feature + Feature
    "thermal+waterproof": "/collections/waterproof-thermal-gloves",
    "waterproof+windproof": "/collections/waterproof-windproof-gloves",
    "thermal+touchscreen": "/collections/thermal-touchscreen-gloves",
    "thin+thermal": "/collections/thin-thermal-gloves",
    "thin+waterproof": "/collections/thin-waterproof-gloves",
    // Feature + Industry
    "gardening+waterproof": "/collections/waterproof-gardening-gloves",
    "gardening+thermal": "/collections/thermal-gardening-gloves",
    "fingerless+driving": "/collections/fingerless-driving-gloves",
    "gardening+heavy-duty": "/collections/heavy-duty-gardening-gloves",
    "heavy-duty+welding": "/collections/heavy-duty-welding-gloves",
    // Feature + Coating
    "coating:nitrile+heavy-duty": "/collections/heavy-duty-nitrile-gloves",
    "coating:rubber+heavy-duty": "/collections/heavy-duty-rubber-gloves",
    // Disposable + Coating/Material
    "coating:nitrile+disposable": "/collections/disposable-nitrile-gloves",
    "coating:rubber+disposable": "/collections/disposable-rubber-gloves",
    "coating:latex+disposable": "/collections/latex-disposable-gloves",
    "coating:latex-free+disposable": "/collections/non-latex-disposable-gloves",
    "disposable+material:vinyl": "/collections/disposable-vinyl-gloves",
    // Disposable + Feature
    "biodegradable+disposable": "/collections/eco-disposable-gloves",
    "disposable+eco": "/collections/eco-disposable-gloves",
    "disposable+heavy-duty": "/collections/heavy-duty-disposable-gloves",
    // Disposable + Industry
    "disposable+food": "/collections/cooking-gloves-disposable",
    // Cut-resistant + Material
    "cut-resistant+liner:leather": "/collections/cut-resistant-leather-gloves",
    "cut-resistant+thermal": "/collections/cut-resistant-thermal-gloves",
    // Thermal + Material
    "liner:leather+thermal": "/collections/thermal-leather-gloves",
    // Fingerless + Material
    "fingerless+liner:leather": "/collections/fingerless-leather-gloves",
    // Industry + Material
    "driving+liner:leather": "/collections/leather-driving-gloves",
    "gardening+liner:leather": "/collections/leather-gardening-gloves",
    // Shoe Style + Vendor
    "shoe:wellington-boots+vendor:dunlop": "/collections/dunlop-wellingtons",
   // Shoe Standards + Shoe Style
    "shoe-std:composite-toe-cap+shoe:safety-shoes": "/collections/composite-safety-shoes",
    "shoe-std:composite-toe-cap+shoe:safety-trainers": "/collections/composite-safety-trainers",
    "shoe-std:composite-toe-cap+shoe:safety-boots": "/collections/composite-safety-boots",
    "shoe-std:steel-toe-cap+shoe:safety-shoes": "/collections/steel-toe-cap-shoes",
    "shoe-std:steel-toe-cap+shoe:safety-trainers": "/collections/steel-toe-cap-trainers",
    "shoe-std:steel-toe-cap+shoe:safety-boots": "/collections/steel-toe-cap-boots",
    // Gender + Workwear
    "gender:women+summer-workwear": "/collections/ladies-summer-workwear",
    // Hi-Vis + Sleeve
    "hi-vis-polo+workwear:long-sleeve": "/collections/hi-vis-polo-long-sleeve",
    "hi-vis-tshirt+workwear:long-sleeve": "/collections/hi-vis-long-sleeve-t-shirt",
    "hi-vis-vest+workwear:long-sleeve": "/collections/long-sleeve-hi-vis-vests"
  };

  // ============================================================
  // Collection Handle → Token Map
  // ============================================================
  const COLLECTION_TO_TOKEN = {
    "disposable-gloves": "disposable",
    "thermal-insulated-gloves": "thermal",
    "all-cut-resistant-gloves": "cut-resistant",
    "all-heat-resistant-gloves": "heat-resistant",
    "chemical-resistant-gloves": "chemical",
    "waterproof-work-gloves": "waterproof",
    "fingerless-work-gloves": "fingerless",
    "leather-gloves": "liner:leather",
    "cold-resistant-gloves": "cold",
    "impact-gloves": "impact",
    // Coating collections (for bidirectional routing)
    "nitrile-gloves": "coating:nitrile",
    "latex-gloves": "coating:latex",
    "rubber-latex-gloves": "coating:rubber",
    "latex-free-gloves": "coating:latex-free",
    "vinyl-gloves": "material:vinyl",
    // Feature collections
    "biodegradable-gloves": "biodegradable",
    "heavy-duty-work-gloves": "heavy-duty",
    "touch-screen-work-gloves": "touchscreen",
    "thin-work-gloves": "thin",
    "windproof-gloves": "windproof",
    // Industry collections
    "food-tested-gloves": "food",
    "mechanics-gloves": "mechanics",
    "driving-gloves": "driving",
    "gardening-gloves": "gardening",
    "welding-gloves": "welding",
    // Shoe collections
    "wellington-boots": "shoe:wellington-boots",
    "safety-shoes": "shoe:safety-shoes",
    "work-safety-trainer-protective-footwear": "shoe:safety-trainers",
    "work-boots": "shoe:safety-boots",
    // Shoe standards collections
    "composite-toe-cap": "shoe-std:composite-toe-cap",
    "steel-toe-cap": "shoe-std:steel-toe-cap",
    // Vendor collections
    "dunlop": "vendor:dunlop",
    "dunlop-safety-footwear": "vendor:dunlop",
    // Workwear collections
    "summer-workwear": "summer-workwear",
    // Hi-Vis collections
    "hi-vis-polo-shirts": "hi-vis-polo",
    "hi-vis-t-shirts": "hi-vis-tshirt",
    "hi-vis-vests": "hi-vis-vest"
  };


  // ============================================================
  // Router Logic
  // ============================================================
  const currentPath = window.location.pathname;
  const currentHandle = currentPath.split("/collections/")[1]?.split(/[/?]/)[0] || "";
  const baseToken = COLLECTION_TO_TOKEN[currentHandle] || null;

  // Pre-normalize keys
  const CURATED_NORMALIZED = {};
  for (const [k, v] of Object.entries(CURATED)) {
    CURATED_NORMALIZED[[...new Set(k.split("+"))].sort().join("+")] = v;
  }

  // Reverse lookup: token → its canonical single-token collection URL
  const TOKEN_TO_COLLECTION = {};
  for (const [handle, token] of Object.entries(COLLECTION_TO_TOKEN)) {
    if (!TOKEN_TO_COLLECTION[token]) {
      TOKEN_TO_COLLECTION[token] = "/collections/" + handle;
    }
  }

  // Detect if current page is a curated destination (not in COLLECTION_TO_TOKEN)
  const CURATED_HANDLES = new Set(
    Object.values(CURATED).map(url => url.split("/collections/")[1]).filter(Boolean)
  );
  const isCuratedPage = CURATED_HANDLES.has(currentHandle);

  function getRedirectTarget() {
    const checkboxes = document.querySelectorAll('.facets__filters input[type="checkbox"]:checked');
    const tokens = [];
    for (const cb of checkboxes) {
      // First, check if it's a GID-based filter (metaobjects)
      const gidToken = GID_TO_TOKEN[cb.value];
      if (gidToken) {
        tokens.push(gidToken);
        continue;
      }
      
      // Then check if it's a vendor filter (string-based)
      // Vendor checkboxes have name="filter.p.vendor" and value is the vendor name
      const inputName = cb.getAttribute('name');
      if (inputName === 'filter.p.vendor') {
        const vendorToken = VENDOR_TO_TOKEN[cb.value];
        if (vendorToken) tokens.push(vendorToken);
      }
    }
    if (tokens.length === 0) return null;

    const withBase = baseToken ? [...tokens, baseToken] : tokens;
    const keyWithBase = [...new Set(withBase)].sort().join("+");
    const keyWithoutBase = [...new Set(tokens)].sort().join("+");

    const target = CURATED_NORMALIZED[keyWithBase] || CURATED_NORMALIZED[keyWithoutBase];
    if (target && currentPath !== target) return target;

    // Reverse routing: on a curated page with a single token checked,
    // route to that token's parent collection instead of AJAX filtering
    // the curated collection (which would give misleading results)
    if (isCuratedPage && tokens.length === 1) {
      const parentUrl = TOKEN_TO_COLLECTION[tokens[0]];
      if (parentUrl && currentPath !== parentUrl) return parentUrl;
    }

    return null;
  }

  function showLoading() {
    const results = document.getElementById("filter-results");
    if (results) results.classList.add("is-loading");
  }

  // CAPTURE phase runs BEFORE facet-filters handlers
  document.addEventListener("change", function(e) {
    const checkbox = e.target.closest('.facets__filters input[type="checkbox"]');
    if (!checkbox) return;

    const target = getRedirectTarget();
    if (target) {
      e.stopImmediatePropagation();
      e.preventDefault();
      showLoading();
      window.location.assign(target);
    }
  }, true);